export const byCountryPortfolioChart = {
    title: '技術ポートフォリオ　国別比較',
    description:
        '選択した国が保有する特許出願が含まれる技術群（クラスタ）を表示しています。\nクラスタの配置はクラスタ&バリューチェーンと同様にテーマ全体の動向を表す一方、バブルの大きさが各国固有の数値（スコアなど）を表します。',
    copy: 'コピー',
    download: 'ダウンロード',
    setting: '設定',
    labelFixedMsg: 'クラスタを選択するにはラベル固定をオフにしてください',

    // csvのヘッダー
    column1: 'クラスタID',
    column2: 'クラスタ名',
    column3: '領域',
    column4: 'スコア（クラスタ）',
    column5: '市場期待値',
    column6: '国名',
    column7: '国コード',
    column8: 'スコア（技術競争力）',
    column9: 'スコア（平均値）',
    column10: '特許出願数',
    column11: '重要特許数',
    column12: '重要特許率',
    column13: '被引用数（合計）',
    column14: '平均被引用数（特許単位）',
    column15: '平均被引用数（企業単位）',
    column16: '平均被引用数（上位N）'
}
